import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProposalForm from './components/ProposalForm';
import ProposalResult from './components/ProposalResult';
import { Toaster } from './components/Toaster';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background">
        <div className="container py-8">
          <h1 className="text-4xl font-bold tracking-tight text-center mb-2">Project Proposal Generator</h1>
          <p className="text-muted-foreground text-center mb-8">Generate professional project proposals in minutes</p>
          <Routes>
            <Route path="/" element={<ProposalForm />} />
            <Route path="/result" element={<ProposalResult />} />
          </Routes>
        </div>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;